import React, { Suspense } from 'react';
import { SuspenseContext } from './SuspenseContext';
const AlloySuspense = _ref => {
  let {
    emitSuspenseEvents = false,
    fallback,
    children
  } = _ref;
  return emitSuspenseEvents ? children : /*#__PURE__*/React.createElement(SuspenseContext.Provider, {
    value: {
      hasSuspenseWrapper: true
    }
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: fallback
  }, children));
};
export default AlloySuspense;
//# sourceMappingURL=AlloySuspense.js.map